export const STATUS_ORDER = [
    "Draft",
    "Submitted",
    "Under Review",
    "On-Site Scheduled",
    "Phone Scheduled",
    "Rescheduled",
    "On Hold",
    "Estimate",
    "Work Order",
    "Rejected",
    "Completed",
    "Closed"
  ];
 

  export const STATUS_RULES = {
    "Draft": {
      canEdit: true,
      isCompleted: false,
      canDelete: true,
      canSubmit: true,
      nextStatuses: ["Submitted"],
      cannotGoBack: true
    },
    "Submitted": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "On Hold"],
      cannotGoBack: true
    },
    "Under Review": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [
        "On-Site Scheduled",
        "Phone Scheduled",
        "On Hold",
        "Rejected"
      ],
      cannotGoBack: false
    },
    "On-Site Scheduled": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [
        "Under Review",
        "On Hold",
        "Rejected"
      ],
      cannotGoBack: false
    },
    "Phone Scheduled": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [
        "Under Review",
        "Rejected"
      ],
      cannotGoBack: true
    },
    "Rescheduled": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [
        "Under Review",
        "Rejected"
      ],
      cannotGoBack: true
    },
    "On Hold": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [
        "Under Review",
        "Rejected"
      ],
      cannotGoBack: true
    },
    "Estimate": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Work Order": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Rejected": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Completed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Closed"],
      cannotGoBack: true
    },
    "Closed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    }
  };
  

  
export const getStatusRules = (currentStatus) => {
  return STATUS_RULES[currentStatus] || {};
};
  
// const currentStatus = "Under Review";
// const rules = getStatusRules(currentStatus);

// console.log("Can Edit:", rules.canEdit); // true
// console.log("Next Status Options:", rules.nextStatuses); // ["Assessment / Estimate / Work Order", "On Hold", "Canceled"]

export const canTransition = (currentStatus, nextStatus) => {
    const rules = getStatusRules(currentStatus);
    return rules.nextStatuses.includes(nextStatus);
  };
  
// const nextStatus = "Submitted";
// if (canTransition(currentStatus, nextStatus)) {
//   console.log("Transition allowed");
// } else {
//   console.log("Transition NOT allowed");
// }
